export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.footerNav = payload;

  return newState;
};
